export const clientProjectOptions = (labelKey, valueKey, array) => {
    return array.map(item => {
      return {
      label: item[labelKey] || item?.typId[labelKey] || "",
      value: item[valueKey] || ""
    }
    }
  );
  };
